const ThemeTablePoster = () =>
  import('@/views/main/dataList/themeTablePoster.vue')
export default {
  path: '/main/dataList/themeTablePoster/:id',
  name: 'ThemeTablePoster',
  component: ThemeTablePoster,
  children: []
}
